import React from 'react';


/**
 *
 * Speaker icon SVG
 *
 * @param { string } textColor css class corresponds to a .my-sofology-logo color class
 *
 */
function SpeakerIcon() {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="1.4142"
      version="1.1"
      viewBox="0 0 199 178"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
    >
      <path
        d="m178.43-1c-4.802 0-10.164 1.456-15.82 4.536l-72.198 39.389h-55.412c-19.25 0-35 15.75-35 35v21c0 19.25 15.75 35 35 35h55.412l72.198 39.389c5.656 3.08 11.018 4.536 15.82 4.536 12.418 0 21.056-9.772 21.056-26.425v-126c0-16.66-8.631-26.425-21.056-26.425zm0.056 145.05c0 7.7-5.53 10.983-12.292 7.294l-53.438-29.148c-6.762-3.689-13.349-7.28-14.644-7.987-1.295-0.714-3.556-1.288-5.026-1.288h-16.681-41.405c-7.7 0-14-6.3-14-14v-21c0-7.7 6.3-14 14-14h58.093c1.47 0 3.731-0.574 5.026-1.288 1.295-0.707 7.882-4.291 14.644-7.987l53.438-29.148c6.762-3.689 12.292-0.406 12.292 7.294v111.26h-7e-3z"
        fillRule="nonzero"
      />
    </svg>
  );
}

export default SpeakerIcon;



// WEBPACK FOOTER //
// ./src/layout/graphics/SpeakerIcon.js